const mediaQueries = {
  mobile: "@media screen and (max-width: 600px)",
  large: "@media screen and (min-width: 1900px)",
};

export default mediaQueries;
